import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { handleActions } from 'redux-actions';
import { fetchGruserSuccess } from '../actions/gruser';
const defaultState = {};
export default handleActions({
    [fetchGruserSuccess.toString()]: (state, action)=>_object_spread({}, state, action.payload)
}, defaultState);
